export default {
    LATEST_NEWS_IDENTIFIER: 'latest',
};
